import { useNavigate } from "react-router-dom";
import { useUserDataStore } from "../../../stores/user";

interface Course {
  id: string;
  name: string;
}

interface Book {
  id: string;
  name: string;
}

interface Package {
  id: string;
  name: string;
}

interface TransactionRowProps {
  id: string;
  studentName: string;
  studentEmail: string;
  paymobOrderId: string;
  amount: string;
  paymentMethod: string;
  success: boolean;
  pending: boolean;
  courses: Course[];
  books: Book[];
  packages: Package[];
  createdAt: string;
}

const TransactionRow = ({
  studentName,
  studentEmail,
  paymobOrderId,
  amount,
  paymentMethod,
  success,
  pending,
  createdAt,
}: TransactionRowProps) => {
  const navigate = useNavigate();
  const { userData } = useUserDataStore();
  const basePath = userData?.role === "sales" ? "/sales/dashboard" : "/dashboard";

  const getStatusBadge = () => {
    if (pending) {
      return (
        <span className="px-2 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800">
          Pending
        </span>
      );
    }
    if (success) {
      return (
        <span className="px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
          Success
        </span>
      );
    }
    return (
      <span className="px-2 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800">
        Failed
      </span>
    );
  };



  return (
    <tr className="border-b border-gray-200 hover:bg-gray-50">
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="font-medium text-gray-900">{studentName}</div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="text-gray-600">{studentEmail}</div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="text-gray-900 font-mono text-xs">{paymobOrderId}</div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="font-semibold text-gray-900">{amount}</div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="text-gray-600">{paymentMethod}</div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        {getStatusBadge()}
      </td>

      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="text-gray-600 text-xs">{createdAt}</div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <button
          onClick={() => navigate(`${basePath}/transactions/${paymobOrderId}`)}
          className="text-blue-600 hover:text-blue-800 text-sm"
        >
          View Details
        </button>
      </td>
    </tr>
  );
};

export default TransactionRow;